<template>
	<div>
		<v-file-input
				chips
				accept=".csv"
				label="Choose File"
				v-model="file"
				@change="checkFileInfo"
				hint="Upload CSV (Comma Separated)"
		></v-file-input>

		<div v-if="fileInfo.status">
			<div id="file-info pt-3">
				<pre id="file-info-pre" v-if="fileInfo.message">{{ fileInfo.message }}</pre>
			</div>
			<div v-if="headerMappings && headerMappings.length">
				<h3>Match Column Labels</h3>
				<div >
					<v-data-table
							:headers="mappingTableHeaders"
							:items="headerMappings"
							hide-default-footer
							class="elevation-1"
					>
						<template v-slot:item.field="{item}">
							<v-select
								v-model="item.field"
								:items="fillableFields"
								label="Select One"
								item-text="name"
								item-value="id"
							>
							</v-select>
						</template>
					</v-data-table>
				</div>
			</div>
			<div class="pt-3 pb-3">
				<button type="button" class="preview btn btn-primary mr-1" :class="{'btn-sm': layout==='v1'}" @click="previewFile">Preview Upload</button>
			</div>
			<div v-if="previewItems.length">
				<div class="item-table">
					<div class="d-flex flex-fill justify-content-between">
						<div class="d-flex flex-fill justify-content-start">{{itemName}}</div>
						<div class="d-flex flex-fill justify-content-end">
											<span v-if="uploadResults">
												<i class="fa fa-check-circle text-success"></i> {{ uploadResults.success }}
												<i class="fa fa-times-circle text-danger"></i> {{ uploadResults.error }}
											</span>
							<span v-else><b>{{ fileContent.length - 1 }}</b> {{itemName}} to upload</span>
						</div>
					</div>
					<div class="">
						<div class="progress push" v-if="uploadResults && uploadResults.progress">
							<div class="progress-bar progress-bar-striped progress-bar-animated bg-info"
								 role="progressbar"
								 :style="'width: '+Math.floor((uploadResults.progress/fileContent.length)*100)+'%;'"
								 :aria-valuenow="Math.floor((uploadResults.progress/fileContent.length)*100)"
								 aria-valuemin="0" aria-valuemax="100">
								<span class="font-size-sm font-w600">{{ Math.floor((uploadResults.progress/fileContent.length)*100) }}%</span>
							</div>
						</div>

						<v-data-table
								:headers="computedHeaders"
								:items="previewItems"
								class="elevation-1"
								:items-per-page="10"
						>
							<template v-slot:item.results="{item}">
								<span v-if="item.error" class="text-danger"><i
										class="fa fa-times-circle mr-3"></i><small>{{ item.error }}</small></span>
								<span v-else><i class="fa fa-check-circle text-success"></i> </span>
							</template>
						</v-data-table>
					</div>
				</div>
			</div>
		</div>
		<div class="p-3 d-flex flex-fill border-top" :class="{'justify-content-end':layout==='v1', 'justify-content-start':layout==='v2'}">
			<button type="button" class="cancel-upload btn btn-sm btn-danger mr-1" v-if="file && layout==='v1'" @click="cancelImport">Cancel</button>
			<div v-if="previewItems.length">
				<button class="btn btn-primary mr-1" :class="{'btn-sm': layout==='v1'}" @click.prevent="uploadFile"
						v-if="(!uploadResults || !uploadResults.error || uploadResults.error === 0) && fileInfo.status !== 4"
						:disabled="uploadResults && uploadResults.progress > 0"><i class="fa fa-spinner fa-spin mr-1"
																				   v-if="uploadResults && uploadResults.progress"></i><i
						class="fa fa-upload mr-1" v-else></i>Upload
				</button>
				<button class="btn btn-danger mr-1" :class="{'btn-sm': layout==='v1'}"
						v-if="uploadResults && uploadResults.error && uploadResults.error > 0"
						@click.prevent="downloadErrors"><i class="fa fa-download mr-1"></i>Download Errors
				</button>
			</div>
			<button type="button" class="cancel-upload btn btn-danger mr-1" v-if="file && layout==='v2'" @click="cancelImport">Cancel</button>
			<button type="button" class="cancel-upload btn btn-light mr-1" :class="{'btn-sm': layout==='v1'}" @click="doneImport"
					v-if="fileInfo.status === 4 && showDoneButton">Done
			</button>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		itemName:{
			type:String,
			default: ''
		},
		importItem:{
			type:Object,
			required:true
		},
		showDoneButton: {
			type:Boolean,
			default: true
		},
		partnerId: {
			type: Number,
			required: true
		},
		layout: {
			type: String,
			default:'v1'
		}
	},
	data: () => {
		return {
			errors: [],
			fillableFields:[],
			headerMappings:[],
			previewItems: [],
			success_msg: '',
			error_msg: '',
			isUploading: false,
			file: null,
			fileInfo: {status: 0, message: ''},
			fileContent: [],
			uploadResults: null,
			isLoading: false,
			importTrackingId: null,
			mappingTableHeaders:[
				{ text: 'File Column', align: 'start', sortable: false, value: 'header'},
				{ text: 'DB Column', sortable: false, value: 'field'},
			]
		}
	},
	computed: {
		computedHeaders() {
			return [...this.headerMappings.filter(x => x.field), ...[{text:'Results', value:'results'}]]
		}
	},
	methods: {
		checkFileInfo() {
			if (this.file) {
				const names = this.file.name.split(".");
				let name = names[0];
				for( let i = 1; i < names.length-1; i++ ) {
					name += names[i];
				}
				if (names[names.length-1].toUpperCase() != "CSV") {
					this.fileInfo = {status: 1, message: 'Invalid file type. Please select a .csv file for upload.'};
				} else {
					// this.fileInfo = {status: 2, message: 'File Name: ' + this.file.name + ' | ' + this.file.size + ' Bytes.', name};
					this.fileInfo = {status: 2, message: '', name};

					const vm = this;

					this.fileContent = [];
					this.headerMappings = [];

					const reader = new FileReader();

					reader.onload = function (file) {
						let res = file.target.result;
						if( !res.endsWith('\r\n') ) // sometimes it misses the last element
							res += '\r\n';

						vm.fileContent = $.csv.toArrays(res);

						if( vm.fileContent.length ) {
							vm.headerMappings = vm.fileContent[0].map((x, i) => {
								let field = vm.fillableFields.find(y => y.name.toLowerCase().indexOf(x.toLowerCase()) > -1 || x.toLowerCase().indexOf(y.name.toLowerCase()) > -1); // see if we can predict selected mappings
								return {header:x, text:x, value:i+'', field:field ? field.id : null};
							});
						}
					};
					reader.readAsText(this.file);
				}
			} else {
				this.cancelFile()
			}
		},
		previewFile() {
			// only show the mapped fields
			this.previewItems = this.fileContent.filter((x, i) => i > 0 && i < 50).map(x => {
				let item = {};
				x.forEach((v, i) => {
					item[i] = v;
				});
				return item;
			}); // show the first 50 except the header row
			this.uploadResults = null;
		},
		uploadFile() {
			const vm = this;
			this.isLoading = true;

			this.uploadResults = {success:0, error:0, progress:0};
			const headerMappings = [...this.headerMappings];

			if( this.importItem && this.importItem.defaultValues ) {
				this.fileContent = this.fileContent.map((x, i) => {
					Object.keys(this.importItem.defaultValues).forEach((k) => {
						x.push(i === 0 ? this.importItem.defaultValues[k].name : this.importItem.defaultValues[k].value);
					});
					return x;
				});
				Object.keys(this.importItem.defaultValues).forEach((k) => {
					headerMappings.push({header:this.importItem.defaultValues[k].name, field:k});
				});
			}

			const content = this.fileContent.map(x => x.filter((y, i) => headerMappings[i].field));

			// remove header row
			content.splice(0, 1);
			const attributeMappings = headerMappings.filter(x => x.field);
			// console.log({content, attributeMappings, importFunction: this.importItem.function});
			axios.post('/insert-import', {content, attributeMappings, importFunction: this.importItem.function}).then(response => {
				console.log(response, typeof response.data);
				this.importTrackingId = response.data.trackingId;
				this.uploadResults.progress++; //start dummy loading
				// event will have data returned
			}).catch(error => {
				console.log(error);
				vm.error_msg = error;
			}).finally(() => { this.isLoading = false });
			// }
		},
		downloadErrors() {
			let csvString = this.fileContent[0].join(',')+',Upload Error,\n';

			for(let i=0; i < this.fileContent.length; i++) {
				if( this.fileContent[i].error ) {
					csvString += this.fileContent[i].join(',')+','+this.fileContent[i].error+'\n';
				}
			}

			let anchor = document.createElement('a');
			anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csvString);
			anchor.target = '_blank';
			anchor.download = this.fileInfo.name+'_errors.csv';
			anchor.click();

		},
		cancelFile() {
			this.file = null;
			this.fileInfo = {status: 0, message: ''};
			this.previewItems = [];
			this.fileContent = [];
			this.headerMappings = [];
		},
		uploadComplete() {
			this.$emit('upload-complete', this.uploadResults.success);
		},
		cancelImport() {
			this.cancelFile();
			this.$emit('import-done', false);
		},
		doneImport() {
			this.cancelFile();
			this.$emit('import-done', true);
		}
	},
	mounted() {
		const vm = this;
		this.isLoading = true;

		// get the fillable attributes for the entities of this type.
		this.fillableFields = [{id:'', name: '- Ignore Column -'}];
		this.fileContent = [];
		this.headerMappings = [];

		if( this.importItem && this.importItem.entities ) {
			let url = `/admin/${this.partnerId}/getFillableFields`;
			this.importItem.entities.forEach((entity) => {
				axios.get(url + `/${entity}`).then(response => {
					response.data.forEach((field) => {
						const id = entity+'.'+field;
						vm.fillableFields.push({id, name:Bandwango.prettyId(id)});
					});
				}).catch(error => {
					vm.error_msg = error;
				}).finally(() => {
					if( this.importItem?.fillableFields?.length )
						vm.fillableFields = vm.fillableFields.filter(x => this.importItem.fillableFields.indexOf(x.id) > -1);

					this.isLoading = false;
				});
			});
		}

		Echo.channel('import-event').listen('ImportUpdated', (ev) => {
			console.log(ev);

			if( !this.importTrackingId || this.importTrackingId != ev.trackingId ) return;
			this.uploadResults.progress--; // remove dummy loading

			ev.results.forEach((res, i) => {
				if( res.error && res.error == 'true' ) {
					this.uploadResults.error++;
					this.fileContent[Number(i)+1]['error'] = res.msg;
					this.previewItems[Number(i)]['error'] = res.msg;
					this.previewItems = [...this.previewItems];
				} else {
					this.uploadResults.success++;
				}
				this.uploadResults.progress++;
				this.$forceUpdate();
			});
			this.uploadResults.progress = 0;
			this.fileInfo.status = 4;
			this.uploadComplete()
		})
	},
	watch: {
		isLoading(value) {
			if (value) {
				$().bwLoader(this.$el).start();
			} else {
				$().bwLoader(this.$el).stop();
			}
		},
		success_msg: function(msg) {
			if( msg ) {
				Bandwango.helpers('notify', {align: 'center', type: 'success', icon: 'fa fa-check mr-1', message: msg});
				this.success_msg = '';
			}
		},
		error_msg: function(msg) {
			if( msg ) {
				Bandwango.helpers('notify', {align: 'center', type: 'danger', icon: 'fa fa-exclamation mr-1', message: msg});
				this.error_msg = '';
			}
		},
	}
}
</script>

<style>
	.item-table {
		overflow-x: scroll;
		padding: 5px;
	}
</style>